import {ChangeDetectorRef, Injectable} from "@angular/core";

@Injectable()
export class IntRunNextTickService {
  constructor(private readonly cdr: ChangeDetectorRef) {
  }
  run(callback: Function, timeout = 0) {
    setTimeout(() => {
      callback && callback();
      this.cdr.markForCheck();
    }, timeout)
  }
}
